var s = "_icon_1q1xv_1",
  o = "_outlineKind_1u96s_3",
  t = "_outlineDisabled_1u96s_12",
  i = "_outlineValued_1u96s_29",
  e = "_outlineError_1u96s_37",
  l = "_ghostyKind_1u96s_61",
  n = "_ghostyDisabled_1u96s_78",
  _ = "_ghostyError_1u96s_98",
  u = "_simpleKind_1u96s_121",
  r = "_simpleDisabled_1u96s_146",
  d = "_simpleValued_1u96s_163",
  a = "_simpleError_1u96s_171",
  c = "_buttonGhosty_1u96s_197",
  p = {
    icon: s,
    outlineKind: o,
    outlineDisabled: t,
    outlineValued: i,
    outlineError: e,
    ghostyKind: l,
    ghostyDisabled: n,
    ghostyError: _,
    simpleKind: u,
    simpleDisabled: r,
    simpleValued: d,
    simpleError: a,
    buttonGhosty: c
  };
export { c as buttonGhosty, p as default, n as ghostyDisabled, _ as ghostyError, l as ghostyKind, s as icon, t as outlineDisabled, e as outlineError, o as outlineKind, i as outlineValued, r as simpleDisabled, a as simpleError, u as simpleKind, d as simpleValued };